// Standalone SVG, one file per toast state. Uses currentColor so the SCSS
// (via --toast-accent) drives the colour — never hardcode a colour here.
const InfoIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="10" cy="10" r="7.5" />
    <path d="M10 9.5 L10 14" />
    <circle cx="10" cy="6.6" r="0.7" fill="currentColor" stroke="none" />
  </svg>
)

export default InfoIcon
